import { createBrowserHistory } from "history";

//API CALL TYPE
//const TYPE_LOCAL = "LOCAL";
const TYPE_REST = "REST";
//console.log(77, process.env.NODE_ENV);

//resources
// const API_URL =
//   process.env.NODE_ENV === "production" ? "" : "https://dev.senshost.net/api";
//const API_URL = "http://senshost.com:8015/api";
const SOCKET_URL = "mqtt://senshost.com";
//API contexts
//We will pass this to swagger class constractor if we need different base urls
//const DEFAULT = "";
//const SECONDARY = "/something";

export enum APILIST {
  LOGIN = "login",
  REGISTER = "register",
  HOSTELS = "hostels",
  GET_HOSTEL = "get-hostel",
  GET_ALL_HOSTEL = "get-all-hostel",
  GET_ALL_USERS = "get-all-users"
}

//CONFIG DATA (Please change here only)
const configs = {
  delay: 500,
  dashbordRefreshRate: 1,
  port: 8015,
  appName: "senhost",
  toastDelay: 5000,
  tokenStorage: "TOKEN_PERSIST",
  socket: SOCKET_URL,
  type: TYPE_REST,

  // imageUrl: "http://127.0.0.1:8000/blogs/",
  // context: "http://127.0.0.1:8000/api",

  // imageUrl: "https://afripay-be-p4ftv.ondigitalocean.app/blogs/",
  context: "https://beternal-be-fzsvc.ondigitalocean.app/api/v1",

  // context: "http://127.0.0.1:8000/api/v1",

  history: createBrowserHistory(),
  requestTimeOut: 300000,
  apiList: APILIST,
  tablePageSize: 10,

  // Master switch for paid flows. When false the site runs as free
  // access-code only (single 1 TB tier): paywall UI is hidden, no account
  // is suspended for non-payment, and an access code is required at signup.
  // Must match the backend PAYMENTS_ENABLED flag. Flip back to true to restore.
  paymentsEnabled: false,
};
export default configs;